/**
 * 模块说明：大目录管理
 */
import { Service } from '@/tools'
export class CategoryConfigServer<T extends TOrder.CategoryConfig> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.CategoryConfig}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分批查询配置列表
   * /api/order/categoryConfig/v1/page
   */
  page = <K extends T['ApiPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)
  /**
   * 功能：教材分类树列表
   * /api/order/categoryConfig/v1/textBookTree
   */
  textBookTree = <K extends T['ApiTextBookTree']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextBookTree', data)

 /**
   * 功能：教材分类树列表
   * /api/order/categoryConfig/v1/textBookTree
   */
  textBookSelectTree = <K extends T['ApiTextBookSelectTree']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextBookSelectTree', data)
  /**
   * 功能：教材分类详情
   * /api/order/categoryConfig/v1/textBookDetail
   */
  textBookDetail = <K extends T['ApiTextBookDetail']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextBookDetail', data)

   /**
   * 功能：编辑教材分类
   * /api/order/categoryConfig/v1/updateTextBook
   */
  updateTextBook = <K extends T['ApiUpdateTextBook']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTextBook', data)
 /**
   * 功能：编辑教材分类
   * /api/order/categoryConfig/v1/addTextBook
   */
  addTextBook = <K extends T['ApiAddTextBook']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTextBook', data)
 /**
   * 功能：禁用配置
   * /api/order/categoryConfig/v1/stopConfig
   */
  stopConfig = <K extends T['ApiStopConfig']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiStopConfig', data)

  /**
   * 功能：启用
   * /api/order/categoryConfig/v1/startConfig
   */
  startConfig = <K extends T['ApiStartConfig']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiStartConfig', data)

    /**
   * 功能：导出
   * /api/order/categoryConfig/v1/textBookExport
   */
  textBookExport = <K extends T['ApiTextBookExport']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextBookExport', data)


/**
   * 功能：教材分类顺序调整
   * /api/order/categoryConfig/v1/updateTextBookSort
   */
  updateTextBookSort = <K extends T['ApiUpdateTextBookSort']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTextBookSort', data)

  /**
   * 功能：教材分类顺序调整
   * /api/order/categoryConfig/v1/updateTextBookSortDown
   */
  updateTextBookSortDown = <K extends T['ApiUpdateTextBookSortDown']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTextBookSortDown', data)

  /**
   * 功能：新增配置
   * /api/order/categoryConfig/v1/addConfig
   */
  addConfig = <K extends T['ApiAddConfig']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddConfig', data)
  /**
   * 功能：修改配置
   * /api/order/categoryConfig/v1/updateConfig
   */
  updateConfig = <K extends T['ApiUpdateConfig']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateConfig', data)

}
